@use '../../scss/utility/functions' as utility;

:host {
  display: block;
}
